export const privacyContent = {
  de: `
<h1>Datenschutzerklärung</h1>
<p><strong>Stand: Januar 2026</strong></p>

<h2>1. Verantwortlicher</h2>
<p>
AB-Informatik GmbH<br>
Am Turm 26<br>
53721 Siegburg<br>
Deutschland
</p>
<p>
Telefon: +49 2241 261310<br>
E-Mail: <a href="mailto:info@ab-informatik.net">info@ab-informatik.net</a><br>
Website: <a href="https://www.ab-informatik.net">www.ab-informatik.net</a>
</p>
<p>
Vertretungsberechtigte Geschäftsführer:<br>
Artur Borgart, Stefan Appenburg
</p>

<h2>2. Allgemeine Hinweise</h2>
<p>Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021, DSG). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.</p>

<h2>3. Hosting und Server-Logfiles</h2>
<p>Unser Hosting-Provider erhebt und speichert automatisch Informationen in sogenannten Server-Logfiles, die Ihr Browser automatisch an uns übermittelt:</p>
<ul>
<li>Browsertyp und Browserversion</li>
<li>Verwendetes Betriebssystem</li>
<li>Referrer URL</li>
<li>Hostname des zugreifenden Rechners</li>
<li>IP-Adresse (anonymisiert)</li>
<li>Uhrzeit der Serveranfrage</li>
</ul>
<p><strong>Zweck:</strong> Sicherstellung eines reibungslosen Verbindungsaufbaus, Gewährleistung der Systemsicherheit und -stabilität.</p>
<p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an technischem Betrieb).</p>
<p><strong>Speicherdauer:</strong> Die Logfiles werden nach spätestens 7 Tagen automatisch gelöscht.</p>

<h2>4. SSL/TLS-Verschlüsselung</h2>
<p>Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>

<h2>5. Kontaktformular und E-Mail-Kontakt</h2>
<p>Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.</p>
<p><strong>Verarbeitete Daten:</strong> Name, E-Mail-Adresse, Telefonnummer (optional), Nachrichteninhalt, Art der Anfrage.</p>
<p><strong>Zweck:</strong> Bearbeitung Ihrer Anfrage, Kommunikation mit Ihnen.</p>
<p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Beantwortung).</p>
<p><strong>Speicherdauer:</strong> Anfragen werden nach vollständiger Bearbeitung und Ablauf gesetzlicher Aufbewahrungsfristen gelöscht (in der Regel nach 3 Jahren).</p>
<p><strong>Empfänger:</strong> Ihre Daten werden ausschließlich von unseren Mitarbeitern verarbeitet. Eine Weitergabe an Dritte erfolgt nicht.</p>

<h2>6. Cookies</h2>
<p>Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert.</p>

<h3>6.1 Technisch notwendige Cookies</h3>
<p>Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer Website erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann.</p>
<p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am technischen Betrieb).</p>
<p><strong>Speicherdauer:</strong> Session-Cookies werden nach Beenden Ihres Browser-Besuchs automatisch gelöscht.</p>

<h3>6.2 Cookie-Einstellungen</h3>
<p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.</p>

<h2>7. Chatbot / KI-Assistent</h2>
<p>Auf unserer Website bieten wir einen KI-gestützten Chat-Assistenten an.</p>
<p><strong>Verarbeitete Daten:</strong> Chat-Nachrichten, Session-ID, Zeitstempel.</p>
<p><strong>Zweck:</strong> Beantwortung Ihrer Fragen, Kundenservice.</p>
<p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch Nutzung des Chat-Widgets).</p>
<p><strong>Drittanbieter:</strong> Die KI-Verarbeitung erfolgt über sichere APIs. Ihre Daten werden nicht für Trainings des KI-Modells verwendet.</p>
<p><strong>Speicherdauer:</strong> Chat-Verläufe werden nach 30 Tagen gelöscht.</p>

<h2>8. IT-Security-Risikocheck</h2>
<p>Unser Security-Assessment-Tool sammelt keine personenbezogenen Daten. Die Antworten werden ausschließlich clientseitig (in Ihrem Browser) verarbeitet und nicht an unsere Server übermittelt.</p>

<h2>9. Ihre Rechte als betroffene Person</h2>
<p>Sie haben folgende Rechte:</p>
<ul>
<li><strong>Auskunft (Art. 15 DSGVO):</strong> Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.</li>
<li><strong>Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht, unverzüglich die Berichtigung unrichtiger oder die Vervollständigung Ihrer bei uns gespeicherten Daten zu verlangen.</li>
<li><strong>Löschung (Art. 17 DSGVO):</strong> Sie haben das Recht, die Löschung Ihrer bei uns gespeicherten Daten zu verlangen, soweit nicht gesetzliche Aufbewahrungspflichten oder andere Rechtsgrundlagen der Löschung entgegenstehen.</li>
<li><strong>Einschränkung (Art. 18 DSGVO):</strong> Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen.</li>
<li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</li>
<li><strong>Widerspruch (Art. 21 DSGVO):</strong> Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Ihrer Daten Widerspruch einzulegen.</li>
<li><strong>Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie haben das Recht, erteilte Einwilligungen jederzeit mit Wirkung für die Zukunft zu widerrufen.</li>
<li><strong>Beschwerde (Art. 77 DSGVO):</strong> Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer Daten durch uns zu beschweren.</li>
</ul>

<h3>Kontakt für Datenschutzanfragen</h3>
<p>Für die Ausübung Ihrer Rechte wenden Sie sich bitte an:<br>
E-Mail: <a href="mailto:datenschutz@ab-informatik.net">datenschutz@ab-informatik.net</a><br>
oder schriftlich an die oben genannte Postanschrift.</p>

<h2>10. Datenschutzaufsichtsbehörde</h2>
<p>Zuständige Aufsichtsbehörde in Datenschutzfragen ist:<br>
<strong>Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</strong><br>
Kavalleriestraße 2-4<br>
40213 Düsseldorf<br>
Telefon: 0211/38424-0<br>
E-Mail: poststelle@ldi.nrw.de<br>
Website: <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener">www.ldi.nrw.de</a>
</p>

<h2>11. Speicherdauer</h2>
<p>Sofern nicht spezifisch angegeben, werden personenbezogene Daten nur so lange gespeichert, wie es für die Erfüllung der verfolgten Zwecke notwendig ist. Nach Wegfall des jeweiligen Zwecks werden die Daten routinemäßig gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen (z.B. steuerrechtliche Aufbewahrungsfristen von 6-10 Jahren).</p>

<h2>12. Externe Links</h2>
<p>Unsere Website enthält Links zu externen Websites Dritter. Auf die Einhaltung datenschutzrechtlicher Bestimmungen durch diese Anbieter haben wir keinen Einfluss. Bitte informieren Sie sich auf den verlinkten Websites über den jeweiligen Umgang mit Ihren Daten.</p>

<h2>13. Aktualität und Änderung dieser Datenschutzerklärung</h2>
<p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Januar 2026. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf dieser Website von Ihnen abgerufen werden.</p>

<p><em>Letzte Aktualisierung: 18. Januar 2026</em></p>
  `,
  en: `
<h1>Privacy Policy</h1>
<p><strong>Last updated: January 2026</strong></p>

<h2>1. Controller</h2>
<p>
AB-Informatik GmbH<br>
Am Turm 26<br>
53721 Siegburg<br>
Germany
</p>
<p>
Phone: +49 2241 261310<br>
Email: <a href="mailto:info@ab-informatik.net">info@ab-informatik.net</a><br>
Website: <a href="https://www.ab-informatik.net">www.ab-informatik.net</a>
</p>
<p>
Managing Directors:<br>
Artur Borgart, Stefan Appenburg
</p>

<h2>2. General Information</h2>
<p>The protection of your personal data is of particular concern to us. We process your data exclusively on the basis of statutory provisions (GDPR, TKG 2021, DSG). This privacy policy informs you about the most important aspects of data processing within our website.</p>

<h2>3. Hosting and Server Log Files</h2>
<p>Our hosting provider automatically collects and stores information in so-called server log files that your browser automatically transmits to us:</p>
<ul>
<li>Browser type and version</li>
<li>Operating system used</li>
<li>Referrer URL</li>
<li>Host name of the accessing computer</li>
<li>IP address (anonymized)</li>
<li>Time of server request</li>
</ul>
<p><strong>Purpose:</strong> Ensuring smooth connection setup, guaranteeing system security and stability.</p>
<p><strong>Legal basis:</strong> Art. 6 para. 1 lit. f GDPR (legitimate interest in technical operation).</p>
<p><strong>Storage period:</strong> Log files are automatically deleted after 7 days at the latest.</p>

<h2>4. SSL/TLS Encryption</h2>
<p>This website uses SSL/TLS encryption for security reasons and to protect the transmission of confidential content. You can recognize an encrypted connection by the fact that the address line of the browser changes from "http://" to "https://" and by the lock symbol in your browser line.</p>

<h2>5. Contact Form and Email Contact</h2>
<p>If you send us inquiries via contact form or email, your data from the inquiry form including the contact data you provided will be stored by us for the purpose of processing the inquiry and in case of follow-up questions.</p>
<p><strong>Data processed:</strong> Name, email address, phone number (optional), message content, type of inquiry.</p>
<p><strong>Purpose:</strong> Processing your inquiry, communication with you.</p>
<p><strong>Legal basis:</strong> Art. 6 para. 1 lit. b GDPR (contract initiation) or Art. 6 para. 1 lit. f GDPR (legitimate interest in answering).</p>
<p><strong>Storage period:</strong> Inquiries are deleted after complete processing and expiry of legal retention periods (usually after 3 years).</p>

<h2>6. Your Rights</h2>
<p>You have the following rights:</p>
<ul>
<li><strong>Access (Art. 15 GDPR):</strong> Right to request information about your personal data processed by us.</li>
<li><strong>Rectification (Art. 16 GDPR):</strong> Right to request immediate correction of incorrect data or completion of your data.</li>
<li><strong>Erasure (Art. 17 GDPR):</strong> Right to request deletion of your data stored by us.</li>
<li><strong>Restriction (Art. 18 GDPR):</strong> Right to request restriction of processing of your data.</li>
<li><strong>Data portability (Art. 20 GDPR):</strong> Right to receive your data in a structured, commonly used and machine-readable format.</li>
<li><strong>Objection (Art. 21 GDPR):</strong> Right to object to the processing of your data at any time.</li>
<li><strong>Complaint (Art. 77 GDPR):</strong> Right to lodge a complaint with a data protection supervisory authority.</li>
</ul>

<h3>Contact for Privacy Inquiries</h3>
<p>To exercise your rights, please contact:<br>
Email: <a href="mailto:datenschutz@ab-informatik.net">datenschutz@ab-informatik.net</a><br>
or in writing to the postal address above.</p>

<h2>7. Supervisory Authority</h2>
<p>Competent supervisory authority for data protection matters:<br>
<strong>State Commissioner for Data Protection and Freedom of Information North Rhine-Westphalia</strong><br>
Kavalleriestraße 2-4<br>
40213 Düsseldorf, Germany<br>
Phone: +49 211 38424-0<br>
Email: poststelle@ldi.nrw.de<br>
Website: <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener">www.ldi.nrw.de</a>
</p>

<p><em>Last update: January 18, 2026</em></p>
  `
};
